// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/workload_status.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/workload_status.proto.
 */
export const file_studyo_today_schools_v1_resources_workload_status = /*@__PURE__*/
  fileDesc("CjdzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvd29ya2xvYWRfc3RhdHVzLnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMquAEKDldvcmtsb2FkU3RhdHVzEh8KG1dPUktMT0FEX1NUQVRVU19VTlNQRUNJRklFRBAAEhkKFVdPUktMT0FEX1NUQVRVU19FTVBUWRABEiMKH1dPUktMT0FEX1NUQVRVU19VTkRFUl9USFJFU0hPTEQQAhIgChxXT1JLTE9BRF9TVEFUVVNfQVRfVEhSRVNIT0xEEAMSIwofV09SS0xPQURfU1RBVFVTX0FCT1ZFX1RIUkVTSE9MRBAEQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schools.v1.resources.WorkloadStatus.
 */
export const WorkloadStatusSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_workload_status, 0);

/**
 * All possible workload states of a group of students.
 *
 * @generated from enum studyo.today.schools.v1.resources.WorkloadStatus
 */
export const WorkloadStatus = /*@__PURE__*/
  tsEnum(WorkloadStatusSchema);

